const CollectionUtil = (function (){

    const handleFilterButtonClick = function(){
        const filterDrawerActionBtn = document.querySelectorAll('[filter-drawer-open]');
        [...filterDrawerActionBtn].forEach( btn => {
            btn.addEventListener('click', () => {
                HELPER_UTIL.dispatchCustomEvent(_EVENT_HELPER.showDrawer, document, {
                    drawerType: 'filter',
                });
            })
        })
    }

    const initEvents = function(){
        handleFilterButtonClick();
    }

    return{
        initEvents,
    }

})();

// Infinite Scroll Implementation
const InfiniteScroll = (function() {
    let currentPage = 1;
    let isLoading = false;
    let hasMorePages = true;
    const MAX_AUTO_LOAD_PAGES = 2; // Auto-load up to page 2
    let observer = null;
    let loadMoreButton = null;
    let sectionId = null;
    let collectionUrl = null;

    const createSentinel = function() {
        const sentinel = document.createElement('div');
        sentinel.className = 'infinite-scroll-sentinel';
        sentinel.style.height = '1px';
        sentinel.style.width = '100%';
        sentinel.style.visibility = 'hidden';
        return sentinel;
    };

    const createLoadingSpinner = function() {
        const spinner = document.createElement('div');
        spinner.className = 'infinite-scroll-loading';
        spinner.innerHTML = `
            <div class="spinner">
                <div class="spinner-ring"></div>
            </div>
        `;
        return spinner;
    };

    const createLoadMoreButton = function() {
        const button = document.createElement('button');
        button.className = 'infinite-scroll-load-more btn btn--primary';
        button.textContent = 'Load More Products';
        button.style.display = 'none';
        return button;
    };

    const getNextPageUrl = function(page) {
        const url = new URL(window.location.href);
        url.searchParams.set('page', page);
        return url.toString();
    };

    const fetchNextPage = async function(page) {
        if (isLoading || !hasMorePages) return;
        
        isLoading = true;
        showLoadingSpinner();

        try {
            const url = getNextPageUrl(page);
            const response = await fetch(`${url}&section_id=${sectionId}`);
            
            if (!response.ok) {
                throw new Error(`Failed to fetch next page: ${response.status}`);
            }

            const html = await response.text();
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            
            // Extract products from the response
            const newProducts = doc.querySelector('.collectionList__trending');
            const pagination = doc.querySelector('.pagination__contiainer');
            
            if (newProducts && newProducts.children.length > 0) {
                const productGrid = document.querySelector('.collectionList__trending');
                
                // Append new products
                Array.from(newProducts.children).forEach(child => {
                    productGrid.appendChild(child.cloneNode(true));
                });

                currentPage = page;
                
                // Update URL without page reload
                window.history.pushState({page: page}, '', url);
                
                // Check if there are more pages
                if (!pagination || !pagination.querySelector('.pagination__item--next')) {
                    hasMorePages = false;
                    hideLoadMoreButton();
                } else if (currentPage >= MAX_AUTO_LOAD_PAGES) {
                    // Show load more button after reaching max auto-load pages
                    showLoadMoreButton();
                    if (observer) {
                        observer.disconnect();
                    }
                }
            } else {
                hasMorePages = false;
                hideLoadMoreButton();
            }
        } catch (error) {
            console.error('Error loading more products:', error);
        } finally {
            isLoading = false;
            hideLoadingSpinner();
        }
    };

    const showLoadingSpinner = function() {
        const spinner = document.querySelector('.infinite-scroll-loading');
        if (spinner) {
            spinner.style.display = 'flex';
        }
    };

    const hideLoadingSpinner = function() {
        const spinner = document.querySelector('.infinite-scroll-loading');
        if (spinner) {
            spinner.style.display = 'none';
        }
    };

    const showLoadMoreButton = function() {
        if (loadMoreButton && hasMorePages) {
            loadMoreButton.style.display = 'block';
        }
    };

    const hideLoadMoreButton = function() {
        if (loadMoreButton) {
            loadMoreButton.style.display = 'none';
        }
    };

    const setupIntersectionObserver = function(sentinel) {
        if (!sentinel) return;

        const options = {
            root: null,
            rootMargin: '200px',
            threshold: 0
        };

        observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting && !isLoading && hasMorePages && currentPage < MAX_AUTO_LOAD_PAGES) {
                    fetchNextPage(currentPage + 1);
                }
            });
        }, options);

        observer.observe(sentinel);
    };

    const init = function() {
        const collectionGrid = document.querySelector('#collection-grid');
        if (!collectionGrid) return;

        sectionId = collectionGrid.dataset.id;
        if (!sectionId) return;

        const paginationContainer = document.querySelector('.pagination__contiainer');
        if (!paginationContainer) return;

        // Check if there are multiple pages
        const pagination = document.querySelector('.pagination');
        if (!pagination) return;

        // Get current page from URL
        const urlParams = new URLSearchParams(window.location.search);
        currentPage = parseInt(urlParams.get('page')) || 1;

        // Create and insert sentinel element (visible trigger point)
        const sentinel = createSentinel();
        paginationContainer.parentNode.insertBefore(sentinel, paginationContainer);

        // Create and insert loading spinner
        const spinner = createLoadingSpinner();
        paginationContainer.parentNode.insertBefore(spinner, paginationContainer);

        // Create and insert load more button
        loadMoreButton = createLoadMoreButton();
        paginationContainer.parentNode.insertBefore(loadMoreButton, paginationContainer);

        // Hide original pagination
        paginationContainer.style.display = 'none';

        // Setup load more button click handler
        loadMoreButton.addEventListener('click', () => {
            if (hasMorePages && !isLoading) {
                fetchNextPage(currentPage + 1);
            }
        });

        // Setup intersection observer for auto-loading
        if (currentPage < MAX_AUTO_LOAD_PAGES) {
            setupIntersectionObserver(sentinel);
        } else {
            showLoadMoreButton();
        }

        // Handle browser back/forward buttons
        window.addEventListener('popstate', (event) => {
            if (event.state && event.state.page) {
                window.location.reload();
            }
        });
    };

    return {
        init
    };
})();

document.addEventListener('DOMContentLoaded', () => {
    CollectionUtil.initEvents();
    InfiniteScroll.init();
});
